<template>
  <div>
    <div class="panel-heading order-heading-with-stats">
      <h4 class="panel-title">{{ $t('orders.canceledOrdersTitle') }}</h4>

      <div class="order-heading-right">
        <div class="order-toolbar-buttons">
          <a class="order-toolbar-btn" :class="{ 'order-toolbar-btn--icon-only': !showButtonLabels }" @click="toggleFiltersVisible">
            <i class="material-icons">{{ showFilters ? 'expand_less' : 'expand_more' }}</i>
            <span v-if="showButtonLabels">{{ $t('orders.filtersToggleLabel') }}</span>
          </a>
          <a class="order-toolbar-btn" :class="{ 'order-toolbar-btn--icon-only': !showButtonLabels }" @click="reloadTable">
            <i class="material-icons">cached</i>
            <span v-if="showButtonLabels">{{ $t('datatable.reloadShortLabel') }}</span>
          </a>
          <a v-if="$_has_perm('permanently_delete_canceled_order')" class="order-toolbar-btn" :class="{ 'order-toolbar-btn--icon-only': !showButtonLabels }" @click="permanentlyDeleteAllCanceledOrder()">
            <i class="material-icons" style="color:#c62828">delete_forever</i>
            <span v-if="showButtonLabels">{{ $t('datatable.permanentlyDeleteSelectedOrdersButton') }}</span>
          </a>
          <a class="order-toolbar-display-toggle" @click="$_toggle_toolbar_button_display()">
            <i class="material-icons">{{ showButtonLabels ? 'label_off' : 'label' }}</i>
          </a>
        </div>

        <div class="order-stats-row order-stats-row--compact">
          <div class="order-stat-card">
            <div class="order-stat-icon order-stat-icon--blue"><i class="material-icons">list_alt</i></div>
            <div class="order-stat-text">
              <span class="order-stat-label">{{ $t('reports.totalOrders') }}</span>
              <span class="order-stat-value">{{ summaryTotalOrders }}</span>
            </div>
          </div>
          <div class="order-stat-card">
            <div class="order-stat-icon order-stat-icon--green"><i class="material-icons">attach_money</i></div>
            <div class="order-stat-text">
              <span class="order-stat-label">{{ $t('printLogs.totalAmountLabel') }}</span>
              <span class="order-stat-value">$ {{ summaryTotalAmount.toFixed(2) }}</span>
              <span v-if="qrCodeValues.length > 0" class="order-stat-note">({{ qrCodeValues.length }} selected)</span>
              <span v-else-if="!filterMade" class="order-stat-note">({{ $t('orders.currentPageScopeNote') }})</span>
            </div>
          </div>
          <div class="order-stat-card">
            <div class="order-stat-icon order-stat-icon--purple"><i class="material-icons">today</i></div>
            <div class="order-stat-text">
              <span class="order-stat-label">{{ $t('adminDashboard.ordersTodayLabel') }}</span>
              <span class="order-stat-value">{{ ordersTodayCount }}</span>
              <span class="order-stat-note">({{ $t('orders.currentPageScopeNote') }})</span>
            </div>
          </div>
          <div class="order-stat-card">
            <div class="order-stat-icon order-stat-icon--orange"><i class="material-icons">payment</i></div>
            <div class="order-stat-text">
              <span class="order-stat-label">{{ $t('adminDashboard.pendingPaymentsLabel') }}</span>
              <span class="order-stat-value">{{ pendingPaymentsCount }}</span>
              <span class="order-stat-note">({{ $t('orders.currentPageScopeNote') }})</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          ref="preDatatable"
          :permissions="{ delete_canceled_order: 'delete_canceled_order', permanently_delete_canceled_order: 'permanently_delete_canceled_order' }"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :hideReloadButton="true"
          :collapsibleFilters="true"
          :filtersVisible="showFilters"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :searchMe="searchMe"
          :enableCustomerSearchSuggestions="true"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :resetGetResults2="resetGetResults2"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :storageKey="'cols_canceledOrder_v2'"
          :defaultHideCol="defaultHideCol"
          :filterMade="filterMade"
          :totalResult="totalResult"
          :warehouseFilterItems="warehouses"
          :warehouseFilterChange="handleWarehouseFilter"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <div class="table-responsive oc-table-shell">
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
                :style="r.is_ship_only == '1' ? 'background-color: rgba(20, 130, 20, 0.4)' : (qrCodeValues.find(x => x == r.order_id) ? 'background-color: #FFF9C4' : '' ) "
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[r.order_id]"
                    v-model="qrCodeValues"
                  />
                </td>
                <td class="oc-cell hover-container">
                  <div class="oc-order-number">#{{ r.theOrderID }}</div>
                  <div class="oc-order-sub"><view-order-users :orderData="r" /></div>
                </td>
                <td class="oc-cell ws-nowrap">
                  <customer-device-icon :orderSource="r.order_source" />
                  <img v-if="r.profile_image" :src="`${$_image_path()}${r.profile_image}`" class="customer-profile-image" />
                  <span class="customer-name-stack">
                    <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break: break-word; white-space: pre-line;">
                      {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                    </span>
                    <span v-else>
                      {{ r.full_name }}
                    </span>
                    <span v-if="r.customer_id_fk" class="oc-customer-id">ID: {{ r.customer_id_fk }}</span>
                    <span v-if="r.phone_number" class="customer-phone-line">{{ r.phone_number }}</span>
                    <span v-if="r.phone_number_2" class="customer-phone-line">{{ r.phone_number_2 }}</span>
                  </span>
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td class="oc-cell">
                  <div class="oc-item-name">{{ r.product_name.substr(0, 35) + (r.product_name.length > 35 ? '...' : '') }}</div>
                  <div class="oc-item-sub" v-if="r.brand">{{ $t('columns.brand') }}: <strong>{{ r.brand }}</strong></div>
                  <a v-if="r.product_url" :href="r.product_url" target="_blank" rel="noopener noreferrer" class="oc-item-link">
                    <i class="material-icons">link</i> {{ $t('columns.url') }}
                  </a>
                </td>
                <td class="oc-cell oc-product-cell">
                  <img v-if="r.image" :src="r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`" class="oc-thumb" @click="lightboxImage = r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`; lightboxOpen = true"/>
                  <span v-else class="oc-thumb-placeholder">—</span>
                </td>
                <td class="oc-cell">
                  <span class="oc-status-chip" style="background:#F63049; color:#FFFFFF;">{{ $_status_label(r.status) }}</span>
                  <div class="oc-item-sub" v-if="r.cancel_reason">{{ $t('columns.cancelReason') }}: {{ r.cancel_reason }}</div>
                  <div class="oc-location-line" v-if="r.country">
                    <i class="material-icons oc-location-icon">place</i>{{ r.country }}<span v-if="r.transportation_type_obj"> · {{ r.transportation_type_obj.name.replace('Transportation', '') }}</span>
                  </div>
                </td>
                <td class="combined-cell-td oc-cell">
                  <div class="combined-cell">
                    <div><span class="combined-cell-label">{{ $t('columns.price') }}:</span> {{ r.item_price ? '$' + r.item_price : '—' }}</div>
                    <div><span class="combined-cell-label">{{ $t('columns.shipping') }}:</span> {{ r.internal_shipping_handling ? '$' + r.internal_shipping_handling : '—' }}</div>
                    <div><span class="combined-cell-label">{{ $t('columns.total') }}:</span> {{ r.total_amount ? '$' + r.total_amount : '—' }}</div>
                    <div class="combined-cell-divider"></div>
                    <div><span class="combined-cell-label">{{ $t('columns.qty') }}:</span> {{ r.quantity || '—' }}</div>
                    <div><span class="combined-cell-label">{{ $t('columns.size') }}:</span> {{ r.size || '—' }}</div>
                  </div>
                </td>
                <td class="oc-cell hover-container" style="min-width: 150px">
                  <view-order-dates :orderData="r" stack-time />
                  <span
                    v-if="r.payment_status"
                    class="oc-payment-chip"
                    :style="{ background: paymentStatusColor(r.payment_status, r.invoice_edit_count).bg, color: paymentStatusColor(r.payment_status, r.invoice_edit_count).color }"
                  >{{ paymentStatusLabel(r.payment_status) }}</span>
                </td>
                <td class="oc-cell oc-actions-cell">
                  <div class="oc-actions-grid">
                    <a
                      v-if="$_has_perm('view_order_detail')"
                      class="oc-action-btn"
                      :tooltip="$t('orders.viewDetails')"
                      @click="initDetail('modal_showApp', r.order_id)"
                    >
                      <i class="material-icons" style="color:#01579B">aspect_ratio</i>
                    </a>
                    <a
                      v-if="$_has_perm('undo_cancel_order')"
                      class="oc-action-btn"
                      :tooltip="$t('orders.returnToNewOrderTooltip')"
                      @click="undoCancelOrder(r.order_id,1)"
                    >
                      <i class="material-icons" style="color:#15019BFF">arrow_upward</i>
                    </a>
                    <a
                      v-show="r.is_ship_only != '1' && r.process_date != null"
                      v-if="$_has_perm('undo_cancel_order')"
                      class="oc-action-btn"
                      :tooltip="$t('orders.returnToProcessedOrderTooltip')"
                      @click="undoCancelOrder(r.order_id,2)"
                    >
                      <i class="material-icons" style="color:#15019BFF">undo</i>
                    </a>
                  </div>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>
          </div>

          <div v-if="isMobile" class="moc-container">
            <div
              v-for="(r, index) in apiResults"
              :key="r.order_id"
              class="moc-card"
              :style="qrCodeValues.find(x => x == r.order_id) ? 'border-left: 3px solid #FBC02D;' : ''"
            >
              <div class="moc-header">
                <input
                  :id="'cb' + index"
                  type="checkbox"
                  :value="[r.order_id]"
                  v-model="qrCodeValues"
                />
                <span class="moc-item-code">{{ r.theOrderID }}</span>
                <span class="moc-status-badge" style="background:#F63049; color:#FFFFFF;">{{ $_status_label(r.status) }}</span>
              </div>
              <div class="moc-body">
                <!-- User -->
                <div class="moc-row">
                  <span class="moc-label">{{ $t('common.user') }}</span>
                  <span class="moc-value"><view-order-users :orderData="r" /></span>
                </div>

                <!-- Customer -->
                <div class="moc-row">
                  <span class="moc-label">{{ $t('columns.customer') }}</span>
                  <span class="moc-value">
                    <customer-device-icon :orderSource="r.order_source" />
                    <img v-if="r.profile_image" :src="r.profile_image && r.profile_image.startsWith('http') ? r.profile_image : `${$_image_path()}${r.profile_image}`" class="customer-profile-image" />
                    <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break:break-word; white-space:pre-line;">
                      {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                    </span>
                    <span v-else>{{ r.full_name }}</span>
                    <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                  </span>
                </div>

                <!-- Item Name -->
                <div class="moc-row">
                  <span class="moc-label">{{ $t('columns.itemName') }}</span>
                  <span class="moc-value">{{ r.product_name.substr(0, 60) + (r.product_name.length > 60 ? '...' : '') }}</span>
                </div>

                <!-- Brand -->
                <div class="moc-row" v-if="r.brand">
                  <span class="moc-label">{{ $t('columns.brand') }}</span>
                  <span class="moc-value">{{ r.brand }}</span>
                </div>

                <!-- URL -->
                <div class="moc-row">
                  <span class="moc-label">{{ $t('columns.url') }}</span>
                  <span class="moc-value">
                    <a v-if="r.product_url" :href="r.product_url" target="_blank" rel="noopener noreferrer" style="color:#01579B;">
                      <i class="material-icons" style="font-size:20px; vertical-align:middle;">link</i>
                    </a>
                    <span v-else style="color:#bbb;">—</span>
                  </span>
                </div>

                <!-- Image -->
                <div class="moc-row" v-if="r.image">
                  <span class="moc-label">{{ $t('columns.image') }}</span>
                  <span class="moc-value">
                    <img
                      :src="r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`"
                      style="width:80px; height:80px; object-fit:cover; border-radius:4px; cursor:pointer;"
                      @click="lightboxImage = r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`; lightboxOpen = true"
                    />
                  </span>
                </div>

                <!-- Warehouse -->
                <div class="moc-row">
                  <span class="moc-label">{{ $t('columns.warehouse') }}</span>
                  <span class="moc-value">{{ r.country || '—' }}</span>
                </div>

                <!-- Price | Shipping | Total -->
                <div class="moc-row--3col">
                  <div>
                    <span class="moc-label">{{ $t('columns.price') }}</span>
                    <span class="moc-value">{{ r.item_price ? '$' + r.item_price : '—' }}</span>
                  </div>
                  <div>
                    <span class="moc-label">{{ $t('columns.shipping') }}</span>
                    <span class="moc-value">{{ r.internal_shipping_handling ? '$' + r.internal_shipping_handling : '—' }}</span>
                  </div>
                  <div>
                    <span class="moc-label">{{ $t('columns.total') }}</span>
                    <span class="moc-value">{{ r.total_amount ? '$' + r.total_amount : '—' }}</span>
                  </div>
                </div>

                <!-- Size -->
                <div class="moc-row" v-if="r.size">
                  <span class="moc-label">{{ $t('columns.size') }}</span>
                  <span class="moc-value">{{ r.size }}</span>
                </div>

                <!-- Cancel Reason -->
                <div class="moc-row" v-if="r.cancel_reason">
                  <span class="moc-label">{{ $t('columns.cancelReason') }}</span>
                  <span class="moc-value">{{ r.cancel_reason }}</span>
                </div>

                <!-- Date -->
                <div class="moc-row">
                  <span class="moc-label">{{ $t('common.date') }}</span>
                  <span class="moc-value"><view-order-dates :orderData="r" /></span>
                </div>
              </div>

              <!-- Card actions -->
              <div class="moc-actions">
                <a
                  v-if="$_has_perm('view_order_detail')"
                  style="color: #01579b" class="rtl-pr-3"
                  :tooltip="$t('orders.viewDetails')"
                  @click="initDetail('modal_showApp', r.order_id)"
                >
                  <i class="material-icons">aspect_ratio</i>
                </a>
                <a
                  v-if="$_has_perm('undo_cancel_order')"
                  style="color: #15019BFF" class="rtl-pr-3"
                  :tooltip="$t('orders.returnToNewOrderTooltip')"
                  @click="undoCancelOrder(r.order_id, 1)"
                >
                  <i class="material-icons">arrow_upward</i>
                </a>
                <a
                  v-if="$_has_perm('undo_cancel_order') && r.is_ship_only != '1' && r.process_date != null"
                  style="color: #15019BFF" class="rtl-pr-3"
                  :tooltip="$t('orders.returnToProcessedOrderTooltip')"
                  @click="undoCancelOrder(r.order_id, 2)"
                >
                  <i class="material-icons">undo</i>
                </a>
              </div>
            </div>
            <v-alert type="error" :value="alertValue"> {{ $t('common.noResultsFound') }} </v-alert>
          </div>

          <!-- Lightbox dialog -->
          <v-dialog v-model="lightboxOpen" max-width="600px">
            <v-card>
              <v-card-text style="padding:8px; background:#000; text-align:center;">
                <img v-if="lightboxImage" :src="lightboxImage" style="max-width:100%; max-height:80vh;" />
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click="lightboxOpen = false">{{ $t('common.close') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <view-order-details
            :detialData="detialData"
            :closeModal="closeModal"
          ></view-order-details>

          <div class="row">
            <div class="col-xs-12 text-center oc-pagination">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from './Pagination.vue'
import preDatatableComponent from './preDatatableComponent.vue'
import DatatableVue from './Datatable.vue'
import viewOrderDetails from './viewOrderDetails.vue'
import axios from 'axios'
import swal from 'sweetalert'
import statusHelpers from '../mixins/statusHelpers'
import toolbarButtonDisplay from '../mixins/toolbarButtonDisplay'

export default {
  mixins: [statusHelpers, toolbarButtonDisplay],
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-order-details': viewOrderDetails
  },
  mounted() {
    this.$_fetch_statuses()
    this.perPageFix()
    this.getWarehouses()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    // Grouped columns (redesign, mirrors allOrder.vue's pattern) -- was a flat 18-column
    // list; each grouped cell stacks several related fields (the cancelled-by user folds
    // into Order Info, cancel reason into Status & Location). Per-column hide now only
    // makes sense at the group level, so defaultHideCol is emptied and storageKey bumped
    // so stale hidden-column selections don't misapply to new positions.
    let columns = [
      { label: '', name: '', text: this.$t('columns.checkBoxColumn'), value: '1' },
      { label: this.$t('columns.orderInfo'), text: this.$t('columns.orderInfo'), value: '2', sortable: true, searchable: true, name: 'theOrderID' },
      { label: this.$t('columns.customer'), text: this.$t('columns.customer'), value: '3', sortable: true, searchable: true, name: 'full_name' },
      { label: this.$t('columns.itemDetails'), text: this.$t('columns.itemDetails'), value: '4', sortable: true, searchable: true, name: 'product_name' },
      { label: this.$t('columns.product'), text: this.$t('columns.product'), value: '5', sortable: false, searchable: false, name: 'image' },
      { label: this.$t('columns.statusLocation'), text: this.$t('columns.statusLocation'), value: '6', sortable: true, searchable: true, name: 'status' },
      { label: this.$t('columns.pricing'), text: this.$t('columns.pricing'), value: '7', sortable: false, searchable: false, name: 'price_all' },
      { label: this.$t('columns.datePayment'), text: this.$t('columns.datePayment'), value: '8', sortable: true, searchable: true, name: 'cancel_date' },
      { label: this.$t('columns.actions'), text: this.$t('columns.actions'), value: '9', sortable: false, searchable: false, name: 'actions' }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      qrCodeValues: [],
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/canceled_order',
      orderDetailUrl: 'api/show_order_detail',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      queryParameter: true,
      detialData: {},
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      columns: columns,
      // Grouped cells can't be hidden field-by-field any more -- same tradeoff allOrder.vue made.
      defaultHideCol: [],
      // Hidden by default (per-page preference, same localStorage convention as allOrder.vue).
      showFilters: localStorage.getItem('filtersVisible_canceledOrder') === 'true',
      sortKey: 'order_id',
      sortOrders: sortOrders,
      warehouses: [],
      lightboxImage: null,
      lightboxOpen: false,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: '',
        warehouse_id_fk: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  computed: {
    summaryTotalOrders() {
      if (this.qrCodeValues.length > 0) return this.qrCodeValues.length
      return this.filterMade
        ? this.apiResults.length
        : (this.pagination.total || this.apiResults.length)
    },
    summaryTotalAmount() {
      return this.apiResults.reduce((sum, r) => sum + (Number(r.total_amount) || 0), 0)
    },
    // Best-effort only: counts within the currently loaded page of apiResults, not a true
    // system-wide count -- hence the "(current page)" note shown alongside it in the stat card.
    ordersTodayCount() {
      const today = new Date().toISOString().split('T')[0]
      return this.apiResults.filter(r => {
        const d = r.cancel_date || r.order_date || r.created_at
        return d && d.substr(0, 10) === today
      }).length
    },
    // Same current-page-only caveat as ordersTodayCount above.
    pendingPaymentsCount() {
      return this.apiResults.filter(r => r.payment_status && r.payment_status !== 'paid').length
    }
  },

  methods: {
    toggleFiltersVisible() {
      this.showFilters = !this.showFilters
      localStorage.setItem('filtersVisible_canceledOrder', this.showFilters ? 'true' : 'false')
    },

    // Replicates preDatatableComponent.vue's own built-in Reload button (now relocated
    // into the panel-heading here) -- reaches into the child's own filter-chip/date-range
    // reset state via $refs since that state lives inside the shared component, not here.
    reloadTable() {
      this.resetGetResults()
      const preDatatable = this.$refs.preDatatable
      if (preDatatable) {
        preDatatable.filterApplied = false
        preDatatable.resetDatePickerDefaults()
        preDatatable.ware = 'Select'
      }
    },

    paymentStatusColor(status, editCount) {
      if (status === 'not_paid' && !Number(editCount)) {
        return { bg: '#E0E0E0', color: '#616161' }
      }
      const map = {
        not_paid: { bg: '#F63049', color: '#FFFFFF' },
        partial_paid: { bg: '#FFC85C', color: '#6B4C00' },
        paid: { bg: '#89D7B7', color: '#1A5940' },
        cancel: { bg: '#FB8C00', color: '#FFFFFF' }
      }
      return map[status] || { bg: '#F5F5F5', color: '#616161' }
    },

    paymentStatusLabel(status) {
      if (!status) return ''
      return status.replace(/_/g, ' ')
    },

    checkAll() {
      this.qrCodeValues = this.apiResults.map(r => [r.order_id])
    },

    unCheckAll() {
      this.qrCodeValues = []
    },

    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    getWarehouses() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.warehouses = []
          let result = response.data.data
          result.forEach((r) => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types, currency: r.currency })
          })
        })
    },

    handleWarehouseFilter(val) {
      this.tableData.warehouse_id_fk = Array.isArray(val) && val.length ? val.join(',') : ''
      this.url = 'api/canceled_order'
      this.getResults()
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      // A selection made before a filter/search/reload must not silently carry over into
      // the new result set — otherwise a stale row (no longer even visible) stays selected
      // and gets included in the next bulk action, affecting rows the user never intended
      // to touch in the current (filtered) view.
      this.qrCodeValues = []

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          const isFlatArray = Array.isArray(data.data)
          if (isFlatArray) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (isFlatArray) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch(errors => { console.error(errors) })
    },

    resetGetResults2() {
      this.resetGetResults()
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.tableData.warehouse_id_fk = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          this.detailResults = data.data
          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    deleteAllCanceledOrder() {
      if (this.qrCodeValues.length === 0) {
        swal({
          text: this.$t('orders.pleaseSelectOrderToDelete'),
          icon: 'warning',
          dangerMode: true
        })
        return
      }
      swal({
        title: this.$t('common.areYouSure'),
        text: this.$t('orders.deleteSelectedCanceledOrdersConfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .post('api/canceled_order/bulk-delete',
              { ids: this.qrCodeValues.map(v => v[0]) },
              { headers: { Authorization: 'Bearer ' + token } }
            )
            .then(() => {
              this.getResults()
              this.unCheckAll()
              swal({
                title: this.$t('common.done'),
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch((error) => {
              if (error.response) {
                swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    permanentlyDeleteAllCanceledOrder() {
      if (this.qrCodeValues.length === 0) {
        swal({
          text: this.$t('orders.pleaseSelectOrderToDelete'),
          icon: 'warning',
          dangerMode: true
        })
        return
      }
      swal({
        title: this.$t('orders.permanentlyDeleteTitle'),
        text: this.$t('orders.permanentlyDeleteCanceledOrdersConfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .post('api/canceled_order/permanent-delete',
              { ids: this.qrCodeValues.map(v => v[0]) },
              { headers: { Authorization: 'Bearer ' + token } }
            )
            .then(() => {
              this.getResults()
              this.unCheckAll()
              swal({
                title: this.$t('common.done'),
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch((error) => {
              if (error.response) {
                swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    undoCancelOrder(orderId, statusId) {
      swal({
        title: this.$t('common.areYouSure'),
        text: this.$t('orders.undoCancelOrderConfirm'),
        icon: 'warning',
        buttons: true
      }).then((confirmed) => {
        if (confirmed) {
          let token = localStorage.getItem('access_token')
          axios
            .put(`api/undo_canceling_order_by_admin/${orderId}`, { status: statusId }, {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(() => {
              this.getResults()
              swal({
                title: this.$t('common.done'),
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch((error) => {
              if (error.response) {
                swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: this.$t('common.typeToSearch'),
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
/* Mobile order cards: see assets/mobile-order-cards.css */

@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td
{
  padding: 0 5px !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.has-error .select2-selection--single:not([class*='bg-']):not([class*='border-']) {
  border-bottom-color: red;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 9999;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-color: #484b4e;
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

.customer-name-stack {
  display: inline-flex;
  flex-direction: column;
  vertical-align: middle;
}
.customer-phone-line {
  display: block;
  font-size: 14px;
  color: #666;
}
.combined-cell-td {
  vertical-align: middle;
}
.combined-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  font-size: 15px;
  line-height: 1.4;
  white-space: nowrap;
}
.combined-cell-label {
  color: #888;
}
</style>



// WEBPACK FOOTER //
// src/components/canceledOrder.vue